const S3_SIGNED_QUERY_KEYS = new Set([
    'AWSAccessKeyId',
    'Expires',
    'Signature',
    'SecurityToken',
    'X-Amz-Algorithm',
    'X-Amz-Credential',
    'X-Amz-Date',
    'X-Amz-Expires',
    'X-Amz-SignedHeaders',
    'X-Amz-Signature',
    'X-Amz-Security-Token',
]);

export const sanitizeS3SignedUrl = (value?: string | null): string => {
    if (value == null || value === '') {
        return '';
    }

    try {
        const parsedUrl = new URL(value);
        let hasChanges = false;

        Array.from(parsedUrl.searchParams.keys()).forEach(key => {
            if (S3_SIGNED_QUERY_KEYS.has(key) || key.startsWith('X-Amz-')) {
                parsedUrl.searchParams.delete(key);
                hasChanges = true;
            }
        });

        if (!hasChanges) {
            return value;
        }

        const search = parsedUrl.searchParams.toString();
        return `${parsedUrl.origin}${parsedUrl.pathname}${
            search.length > 0 ? `?${search}` : ''
        }`;
    } catch {
        return value;
    }
};

export const normalizeMediaUrls = <T extends Record<string, any>>(
    item: T
): T => {
    if (item == null || typeof item !== 'object') {
        return item;
    }

    const normalized = { ...item };
    const normalizedRecord = normalized as Record<string, unknown>;
    const candidateKeys = ['photo', 'thumbnail', 'url', 'thumb'];

    candidateKeys.forEach(key => {
        const currentValue = normalizedRecord[key];
        if (typeof currentValue === 'string') {
            normalizedRecord[key] = sanitizeS3SignedUrl(currentValue);
        }
    });

    return normalized;
};
